import classNames from 'classnames';

import type { LogoSize } from '.';

import styles from './companyLogo.module.css';

interface CompanyLogoSkeletonProps {
  className?: string;
  size?: LogoSize;
}

const CompanyLogoSkeleton = (props: CompanyLogoSkeletonProps) => {
  const { className = '', size = '' } = props;

  return (
    <div
      className={classNames(
        styles['generic-company-logo'],
        styles[size],
        className,
        'animate-flicker'
      )}
    />
  );
};

export default CompanyLogoSkeleton;
